
<!------------------------------------->
<!-- List tab detail layout.
 * File Name ..: master-regions.component.html
 * Generated by: ianday
 * Date .......: 12/12/23
--------------------------------------->
<div class="requesttypes-form-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%">
            <TR>
                <TD class="table-title-cell">
                    <i class="fa fa-cog table-icon-header"
                       style="width: 2em"></i>{{ formTitle }}
                </TD>

                <TD align="left" style="min-width: 400px;">
                    <input text id="txtFilter" #txtFilter
                           matTooltip="Type to match data in all columns except date fields"
                           class="qs_filter-field" [disabled]="this.isEditing"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon>close</mat-icon>
                    </button>
                </TD>
                <TD class="qs-label-cell" style="width: 60px; text-align: center;">Status:</TD>
                <TD style="width: 150px">
                    <mat-select
                            disableOptionCentering
                            [(value)]="selectedStatusFilter" floatLabel="never"
                            class="dw-mat-select"
                            style="font-size: 10pt;width: 120px;"
                            panelClass="local-drop-down-panel"
                            (selectionChange)="txtFilter.value=''; onChangeStatusFilterValue()">
                        <mat-option value='All'>All</mat-option>
                        <mat-option value='Active'>Active</mat-option>
                        <mat-option value='InActive'>InActive</mat-option>
                        <mat-option value='Discontinued'>Discontinued</mat-option>
                    </mat-select>
                </TD>
                <TD class="table-pagination-cell" align="right">{{ pagination }} Record(s) ...</TD>
            </TR>
        </table>
    </div>


        <div class="main-client-area">
            <!--------------------------->
            <!-- RECORDS TABLE         -->
            <!--------------------------->
            <div  [ngClass]="contentClassName" class="table-container mat-elevation-z1"
                 (keydown)="tableKeyDown($event)" tabindex="-1">
                <table mat-table [dataSource]="dataSource" matSort
                       (matSortChange)="onSortChange($event)">

                    <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on
                  the row definition" -->

                    <!-- ID -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef
                            style="background-color: white; z-index:99999; width: 100px;">Id
                        </th>
                        <td mat-cell style="width:100px !important;"
                            *matCellDef="let element;let tableRowIdx = index;">
                            {{ element.id }}
                        </td>
                    </ng-container>
                    <!-- Short Description -->
                    <ng-container matColumnDef="shortDescription">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999; width: 14%">Status Label
                        </th>
                        <td mat-cell style="width:14% !important;"
                            *matCellDef="let element">{{ element.shortDescription }}
                        </td>
                    </ng-container>
                    <!-- Description -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999; width: 50%">Description
                        </th>
                        <td mat-cell style="width:50% !important;"
                            *matCellDef="let element">{{ element.description }}
                        </td>
                    </ng-container>

                    <!--Record Status  -->
                    <ng-container matColumnDef="recordStatus">
                        <th mat-header-cell *matHeaderCellDef
                            style="background-color: white; z-index:99999; width:120px">Record Status
                        </th>
                        <td mat-cell style="width:120px !important;"
                            *matCellDef="let element">{{ lblFinalizeFlag(element.recordStatus) }}
                        </td>
                    </ng-container>
                    <!-- Active Status -->
                    <ng-container matColumnDef="activeStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Status
                        </th>
                        <td mat-cell *matCellDef="let element" >

                            <dw-dropdown *ngIf="selectedRecord?.id == element.id"
                                         [disabled]="isEditing"
                                         [useStatusOptions]="'statusdiscontinued'"
                                         [selectedItem]="element.activeStatus"
                                         [controlWidth]="'120px'"
                                         (itemSelected)="element.activeStatus = $event; onStatusChange(element)">
                            </dw-dropdown>

                            <span *ngIf="selectedRecord?.id !== element.id"
                                  style="padding-left: 3px;">{{element.activeStatus}}</span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)">
                    </tr>
                </table>
                <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
            </div>
            <!-------------------------------------->
            <!-- Control Strip                    -->
            <!-------------------------------------->
            <div class="mat-elevation-z2 control-strip">
                <button *ngIf="visibleAdd" mat-button [disabled]="this.isEditing"
                        matTooltipPosition="above"
                        class="command-button" matTooltip="Add a new record"
                        (click)="addModifyRecord(true)" >
                    <mat-icon>add_circle_outline</mat-icon>
                    Add New
                </button>
                <button *ngIf="visibleModify" class="command-button"
                        matTooltipPosition="above"
                        style="margin-top: 5px;" [disabled]="(Idx < 0|| this.isEditing)"
                        matTooltip="Edit a selected record" (click)="addModifyRecord(false)"
                        mat-button>
                    <mat-icon>edit</mat-icon>
                    Edit
                </button>
                <button *ngIf="visibleDelete" class="command-button"
                        matTooltipPosition="above"
                        style="margin-top: 5px;" [disabled]="(Idx < 0 || this.isEditing)"
                        matTooltip="Remove a selected record" (click)="removeRecord()"
                        mat-button>
                    <mat-icon>remove_circle_outline</mat-icon>
                    Remove
                </button>
            </div>
            <!------------------------------->
            <!--  Detail panel             -->
            <!------------------------------->
            <div id="requesttypes-details-panel" class="requesttypes-detail-container mat-elevation-z2"
                 style="margin-bottom: 2px;">
                <mat-tab-group animationDuration="0ms" (selectedTabChange)="doTabChange()"
                               [(selectedIndex)]=selectedTabIndex>
                    <mat-tab label="Details" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <div class="dwform" style="padding-right: 15px; padding-top: 13px;">

                                <div class="dwform-cell-nopadding" style="min-width: 500px;border-right: 1px solid grey;">

                                    <div class="dwform-row-double-gap"></div>
                                    <div class="dwform-row">
                                        <label class="label-field">ID:</label>
                                        <span class="form-required"> </span>
                                        <input class="input-field-short" style="width:80px" disabled="true"
                                               [(ngModel)]="id"
                                               type="text">
                                    </div>

                                    <div class="dwform-row-gap"></div>
                                    <div class="dwform-row">

                                        <label class="label-field">Label:</label>
                                        <span class="form-required">*</span>
                                        <input class="input-field" id="shortDescription"
                                               [disabled]="!isEditing"
                                               [(ngModel)]="shortDescription"

                                               style="text-transform: capitalize; width:280px"
                                               placeholder="<label>"
                                               type="text">

                                    <div class="dwform-row-gap"></div>

                                        <label class="label-field" style="vertical-align: top;padding-top:3px;">
                                            Description:</label>
                                        <span class="form-required">*</span>
                                        <textarea class="input-field" id="description"
                                                  class="text-area-input"
                                            [disabled]="!isEditing"
                                            [(ngModel)]="description"
                                            style="text-transform: capitalize; width:380px; height: 60px; resize: none;"
                                            placeholder="<Description>"
                                            type="text">
                                        </textarea>

                                        <div class="dwform-row-gap"></div>

                                        <label class="label-field">Status:</label> <span
                                                class="form-required">*</span>
                                            <dw-dropdown
                                                    id="activeStatusId"
                                                    [disabled]="!isEditing"
                                                    [selectedItem]="activeStatus"
                                                    (itemSelected)="activeStatus = $event"
                                                    [controlWidth]="'120px'" [useStatusOptions]="'statusdiscontinued'">
                                            </dw-dropdown>
                                        </div>
                                        
                                        <div class="dwform-row-gap"></div>
                                        
                                        <label class="label-field">Selectable:</label>
												<span class="form-required"></span>
												  <mat-checkbox [(ngModel)]="selectable" binary="true" [disabled]="!isEditing"  matTooltipPosition="below"
							                            matTooltip="Indicates whether the item is available to be selected in the drop-down lists, or if it is hidden for administrative purposes"></mat-checkbox>
										<div class="dwform-row-gap"></div>
										<div class="dwform-row-gap"></div>

                                </div>
                                
                                 <div class="dwform-cell-nopadding" style="min-width: 400px;padding-left: 30px;" *ngIf="visibleActions">
                                  <h3 style="position: absolute;">Actions</h3>
                                  <div class="dwform-row-gap"></div>
                                  <div class="dwform-row-gap"></div>
                                  <div class="dwform-row-gap"></div>
                                  <div><label style="padding-left: 425px;">Enable</label></div>
                                  <div class="dwform-row-gap"></div>
                                  <div class="dwform-row-gap"></div>
                                        <label class="label-field">Communications:</label>
                                        <span class="form-required">*</span>

                                        <dw-dropdown
                                                [disabled]="!isEditing || disableCommunicationSettings || !enableActions"
                                                [controlWidth]="'280px'"
                                                [selectedItem]="selectedMessageDefinitionId"
                                                (itemSelected)="selectedMessageDefinitionId = $event"
                                                [dataSource]="messageDefinitionsList">
                                        </dw-dropdown> 
                                      <button  [disabled]="!isEditing || disableCommunicationSettings || !enableActions" matTooltip="Clear selection" mat-icon-button (click)="clearSelection('com')" aria-label="Clear selection" style="width: 0px; margin-left: -10px;">
									        <mat-icon aria-label="Clear selection" style="font-size:10pt;width:20px;cursor: pointer">clear</mat-icon>
									  </button>
                                        <mat-checkbox style="margin-left:24px;" [(ngModel)]="enableCommunication" binary="true" [disabled]="!isEditing || disableCommunicationSettings || (selectedMessageDefinitionId === undefined || selectedMessageDefinitionId == null || selectedMessageDefinitionId===-1) || !enableActions"  matTooltipPosition="below"
							                            matTooltip="Enable/disable"></mat-checkbox>

                                     <div class="dwform-row-gap"></div>
                                        <label class="label-field">Reassign To:</label>
                                        <span class="form-required">*</span>

                                        <dw-dropdown
                                                [disabled]="!isEditing || !enableActions"
                                                [controlWidth]="'280px'"
                                                [selectedItem]="selectedAgencyId"
                                                (itemSelected)="selectedAgencyId = $event"
                                                [dataSource]="agencyList">
                                        </dw-dropdown>
                                        <button   [disabled]="!isEditing || !enableActions" matTooltip="Clear selection" mat-icon-button (click)="clearSelection('reassignAgency')" aria-label="Clear selection" style="width: 0px; margin-left: -10px;">
									        <mat-icon aria-label="Clear selection" style="font-size:10pt;width:20px;cursor: pointer">clear</mat-icon>
									  	</button>
                                         <mat-checkbox style="margin-left:24px;" [(ngModel)]="enableReassign" binary="true" [disabled]="!isEditing || (selectedAgencyId === undefined || selectedAgencyId == null || selectedAgencyId===-1) || !enableActions"  matTooltipPosition="below"
							                            matTooltip="Enable/disable"></mat-checkbox>
                                        
                                      <div class="dwform-row-gap"></div>
                                        <label class="label-field">Custom Actions:</label>
                                        <span class="form-required">*</span>

                                        <dw-dropdown
                                        		[multiSelect]="true" 
                                                [disabled]="!isEditing || !enableActions"
                                                [controlWidth]="'280px'"
                                                [selectedItem]="selectedCustomactionsList"
                                                (itemSelected)="selectedCustomactionsList = $event"
                                                [dataSource]="customActionsList">
                                        </dw-dropdown>
                                        <button  [disabled]="!isEditing || !enableActions" matTooltip="Clear selection" mat-icon-button (click)="clearSelection('customAction')" aria-label="Clear selection" style="width: 0px; margin-left: -10px;">
									        <mat-icon aria-label="Clear selection" style="font-size:10pt;width:20px;cursor: pointer">clear</mat-icon>
									  	</button>
                                        <mat-checkbox style="margin-left:24px;" [(ngModel)]="enableCustomAction" binary="true" [disabled]="!isEditing || (selectedCustomactionsList === undefined || selectedCustomactionsList == null || selectedCustomactionsList.length===0) || !enableActions"  matTooltipPosition="below"
							                            matTooltip="Enable/disable"></mat-checkbox>
                                  <div class="dwform-row-gap"></div>

                                        <label class="label-field">Record Status:</label>
                                        <span class="form-required">*</span>

                                        <dw-dropdown
                                                [disabled]="!isEditing || !enableActions"
                                                [controlWidth]="'180px'"
                                                [selectedItem]="recordStatus"
                                                (itemSelected)="recordStatus = $event"
                                                [dataSource]="finalizeList">
                                        </dw-dropdown>	
                                 </div>
                                <!----------------------->
                                <!-- ERROR LINE --------->
                                <!----------------------->
                                <div class="error-line" [hidden]='!strErr.length'
                                     style="text-align:left">{{ strErr }}
                                </div>
                                <!----------------------->
                                <!-- SAVE STRIP        -->
                                <!----------------------->
                                <div class="save-close-strip" style="bottom: 3px;">

                                    <button  class="command-button" *ngIf="this.isEditing"
                                            (click)="submitRecord()" matTooltip="Submit the selected record"
                                            mat-button>
                                        <mat-icon>check_circle_outline</mat-icon>
                                        Submit
                                    </button>
                                    <button class="command-button" *ngIf="this.isEditing"
                                            (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
                                        <mat-icon>highlight_off</mat-icon>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="History" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <transaction-history #history></transaction-history>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
</div>
